<template>
  <PersonalAreaTemplate
    :editing="editing"
    :max-width="modal ? null : 888"
    fileAdd
    :files="idNumberData.image"
    :delete-files="idNumberData.deleteFiles"
    maxFilesShow="3"
    maxFiles="3"
    :on-save="onSave"
  >
    <v-form class="d-grid gap-5" ref="form" lazy-validation>
      <BaseInput
        :label="localStorage.translations.pages['setting-personal_area'].labels['id-nomer']"
        :view="!editing"
        v-model="idNumberData.text"
        :placeholder="localStorage.translations.pages['setting-personal_area'].labels['id-nomer']"
        :rules="idNumberData.image.length ? ['required'] : null"
      />
    </v-form>
  </PersonalAreaTemplate>
</template>

<script>
import { mapActions } from 'vuex'

import PersonalAreaTemplate from 'components/personalArea/personalAreaTemplate'
export default {
  name: 'IdNumber',
  props: {
    editing: Boolean,
    id_data: Object,
    employeeId: Number,
    onSave: Function,
    modal: Boolean,
  },
  components: { PersonalAreaTemplate },
  data: () => ({
    idNumberData: {
      text: '',
      image: [],
      deleteFiles: [],
    },
    base64: [],
  }),
  watch: {
    id_data() {
      this.onActualData()
    },
    'idNumberData.image'() {
      for (let i in this.idNumberData.image) {
        if (this.idNumberData.image[i] === null || '') {
          this.idNumberData.image.splice(i, 1)
        }
      }
    },
    idNumberData: {
      deep: true,
      handler() {
        if (this.editing) {
          this.onNavigationGuardianCheck({
            data: { idNumberData: this.idNumberData },
            overwrite: false,
          })
        }
      },
    },
  },
  mounted() {
    this.onActualData()
  },
  computed: {
    personalAreaUserEdit() {
      return this.$route.name === 'PersonalAreaEdit'
    },
  },
  methods: {
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    onActualData() {
      if (this.id_data) {
        this.idNumberData.text = this.id_data.text
        if (this.id_data.image !== undefined || this.id_data.image !== none) {
          this.idNumberData.image = this.id_data.image
        }
      }
      this.onNavigationGuardianCheck({
        data: { idNumberData: this.idNumberData },
        overwrite: true,
      })
    },
    async deleteImageBD() {
      if (this.idNumberData.deleteFiles.length) {
        for (let i in this.idNumberData.deleteFiles) {
          this.$store.dispatch('deleteFile', {
            url: this.idNumberData.deleteFiles[i],
          })
        }
        this.idNumberData.deleteFiles = []
      }
    },
    submitFile(file, i) {
      return new Promise((resolve, reject) => {
        let formData = new FormData()
        formData.append('file', file)
        this.$store
          .dispatch('uploadFile', {
            data: formData,
            use_case: file.type === 'application/pdf' ? null : 'cover',
          })
          .then((response) => {
            this.idNumberData.image[i] = response.data.url
            return resolve(response)
          })
          .catch((err) => {
            this.idNumberData.image.splice(i, 1)
            return reject(err)
          })
      })
    },
    async saveChange() {
      return new Promise(async (resolve, reject) => {
        if (this.$checkNavigationGuardianChange('idNumberData')) {
          await Promise.all(
            this.idNumberData.image.map(async (file, index) => {
              if (typeof file !== 'string') {
                await this.submitFile(file, index)
              }
            }),
          )
          await this.deleteImageBD()
          let data = {
            id_data: JSON.stringify({
              text: this.idNumberData.text,
              image: this.idNumberData.image,
            }),
          }
          resolve(data)
        } else resolve(true)
      })
    },
  },
}
</script>
